export const AUTO_HIDE = 100
export const MAX_HEIGHT = 400
